import * as Sentry from '@sentry/vue';

export function dispatchSentryException(message: string): void {
    Sentry.captureException(new Error(message));
}
